import * as Protocol from "@/js/web/socket/protocol";
import DYLongLinkClient from "@/js/web/socket/websocket";
import DYWebRtcClient from "@js/webrtc";
import { setCurrentGame } from "@js/account";
import eventsCenter, { EVENTCMD } from "@js/events";
import Logger from "@js/logger";

function RetData(
  obj: any,
  code = 0,
  msg = ""
): WebSocketRes<pro.yunpb.IChangeGameRes> {
  return {
    obj,
    code,
    msg,
  };
}

export default class BusinessManager {
  static async SendReq(req: any) {
    if (req) {
      try {
        const ret = await DYLongLinkClient.getInstance().sendRequest(req);
        return RetData(ret);
      } catch (err: any) {
        Logger.log(`BusinessManager send request ${JSON.stringify(err)}`);
        return RetData(err.rpcOut, err.ret, err.msg);
      }
    } else {
      return null;
    }
  }

  // 用户选择游戏进入
  static PlayGame(data: pro.yunpb.ICltPlayGameReq) {
    Logger.log(`PlayGame`);
    const cltPlayGameReq = Protocol.CltPlayGameReq(data);
    return BusinessManager.SendReq(cltPlayGameReq);
  }

  static ConfirmAlreadyMissStatus() {
    Logger.log("ConfirmAlreadyMissStatus");
    const confirmAlready = Protocol.ConfirmAlreadyReq();
    return BusinessManager.SendReq(confirmAlready);
  }

  // 用户退出游戏
  static async ExitGame(user_id: number) {
    Logger.log(`exit game ${user_id}`);
    const cltExitGameReq = Protocol.CltExitGameReq(user_id);
    setCurrentGame(null);
    await BusinessManager.ConfirmAlreadyMissStatus();
    return BusinessManager.SendReq(cltExitGameReq);
  }

  // 用户取消排队
  static async CancelQue(user_id: number) {
    Logger.log(`CancelQue ${user_id}`);
    const cltCancelQueReq = Protocol.CltCancelQueReq(user_id);
    return BusinessManager.SendReq(cltCancelQueReq);
  }

  // 切换游戏
  static async ChangeGame(game_id: number, is_high_level: boolean) {
    Logger.log(`ChangeGame ${game_id}`);
    const cltChangeGameReq = Protocol.CltChangeGameReq(game_id, is_high_level);
    return BusinessManager.SendReq(cltChangeGameReq);
  }

  // 排队面板数据
  static async GetQueuePanel() {
    Logger.log(`GetQueuePanel`);
    const cltGetQueuePanel = Protocol.CltGetQueuePanelReq();
    return BusinessManager.SendReq(cltGetQueuePanel);
  }

  // chikii 排队面板数据
  static async GetGameRoomInfo(gameId: number) {
    Logger.log(`GetGameRoomInfo ${gameId}`);
    const cltGetChikiiQueuePanel = Protocol.CltGetGameRoomInfoReq(gameId);
    return BusinessManager.SendReq(cltGetChikiiQueuePanel);
  }

  // chikii 使用加速卡
  static async CltUseQueueCardReq(cardType: number) {
    Logger.log(`CltUseQueueCardReq ${cardType}`);
    const cltGetChikiiQueuePanel = Protocol.CltUseQueueCardReq(cardType);
    return BusinessManager.SendReq(cltGetChikiiQueuePanel);
  }

  // chikii 获取加速卡数量
  static async CltGetBagItems(userId?: number) {
    Logger.log(`CltGetBagItems ${userId}`);
    const cltGetChikiiQueuePanel = Protocol.CltGetBagItems(userId);
    return BusinessManager.SendReq(cltGetChikiiQueuePanel);
  }

  // 切换到秒进
  static async UsePriority(autoUsePriorityType: number) {
    Logger.log(`UsePriority ${autoUsePriorityType}`);
    const cltUsePriority = Protocol.CltUsePriorityReq(autoUsePriorityType);
    return BusinessManager.SendReq(cltUsePriority);
  }

  // 切换到加时
  static async ChangeQueue() {
    Logger.log(`ChangeQueue`);
    const cltChangeQueue = Protocol.CltChangeQueueReq();
    return BusinessManager.SendReq(cltChangeQueue);
  }

  // 获取可用时间
  static async GetCanUseTime() {
    Logger.log(`GetCanUseTime`);
    const cltGetCanUseTime = Protocol.CltGetCanUseTime();
    return BusinessManager.SendReq(cltGetCanUseTime);
  }

  // 重启游戏
  static async RestartGame(data: Record<string, unknown>) {
    Logger.log(`RestartGame`);
    const cltRestartGame = Protocol.CltRestartGame(data);
    return BusinessManager.SendReq(cltRestartGame);
  }

  // 进入指定服务器
  static async EnterSpecifiedServer(
    user_id: number,
    server_dbid: number,
    device_id: number
  ) {
    Logger.log(`EnterSpecifiedServer ${user_id} ${server_dbid}`);
    const cltSpecifiedSvrReq = Protocol.CltSpecifiedSvrReq(
      user_id,
      server_dbid,
      device_id
    );
    return BusinessManager.SendReq(cltSpecifiedSvrReq);
  }

  static async GetPlayerTime(user_id: number) {
    const playerTimeReq = Protocol.PlayerTimeReq(user_id);
    return BusinessManager.SendReq(playerTimeReq);
  }

  static async GetPlayerStatus(user_id: number) {
    const playerStatusReq = Protocol.PlayerStatus(user_id);
    return BusinessManager.SendReq(playerStatusReq);
  }

  // 发送鼠标键盘
  static HandleScreenCtrl(cmd: any) {
    const webRtcKeyboardReq = Protocol.WebRtcKeyboardReq(cmd);
    const req =
      DYLongLinkClient.getInstance().bulidProtocolMsg(webRtcKeyboardReq);
    const rpcInput = Protocol.RPCInput(
      "chikii.node.NodeExtObj",
      "PushWebRtcKeyboard",
      req
    );
    const proMsg = DYLongLinkClient.getInstance().bulidProtocolRPCMsg(rpcInput);
    proMsg && DYWebRtcClient.getInstance().sendChannelData(proMsg);
    // 重置挂机检测
    eventsCenter.emit(EVENTCMD.ResetAwayFromKeyboard);
  }

  static HandleJoysticCtrl(data: any) {
    const webRtcJoyStickReq = Protocol.WebRtcJoyStickReq(data);
    const req =
      DYLongLinkClient.getInstance().bulidProtocolMsg(webRtcJoyStickReq);
    const rpcInput = Protocol.RPCInput(
      "chikii.node.NodeExtObj",
      "WebRtcJoyStickReq",
      req
    );
    const proMsg = DYLongLinkClient.getInstance().bulidProtocolRPCMsg(rpcInput);
    proMsg && DYWebRtcClient.getInstance().sendChannelData(proMsg);
    // 重置挂机检测
    eventsCenter.emit(EVENTCMD.ResetAwayFromKeyboard);
  }

  static ChangeWebRtcInfo(
    type: string,
    fromUid: number,
    toUid: number,
    content: any
  ) {
    const changeWebRtcInfo = Protocol.ChangeWebRtcReq(
      type,
      fromUid,
      toUid,
      content
    );
    DYLongLinkClient.getInstance().sendRequest(changeWebRtcInfo);
  }

  static ChangeResoultion(type: Protocol.EResolutionType) {
    const webrtcSwitchQualityReq = Protocol.WebrtcSwitchQualityReq(type);
    console.log(webrtcSwitchQualityReq, "ChangeResoultion");

    const req = DYLongLinkClient.getInstance().bulidProtocolMsg(
      webrtcSwitchQualityReq
    );
    console.log(req, "bulidProtocolMsg");

    const rpcInput = Protocol.RPCInput(
      "chikii.node.NodeExtObj",
      "WebrtcSwitchQualityReq",
      req
    );
    const proMsg = DYLongLinkClient.getInstance().bulidProtocolRPCMsg(rpcInput);
    proMsg && DYWebRtcClient.getInstance().sendChannelData(proMsg);
  }

  static WebrtcPing(ping: number) {
    const webrtcPingReq = Protocol.WebrtcPingReq(ping);
    const req = DYLongLinkClient.getInstance().bulidProtocolMsg(webrtcPingReq);
    const rpcInput = Protocol.RPCInput(
      "chikii.node.NodeExtObj",
      "WebrtcPingReq",
      req
    );
    return DYLongLinkClient.getInstance().bulidProtocolRPCMsg(rpcInput);
  }

  static changeGameInfo(node: Record<string, unknown>) {
    Logger.log(`changeGameInfo`);
    const webRtcChangeGamesReq = Protocol.WebRtcChangeGamesReq(node);
    const req =
      DYLongLinkClient.getInstance().bulidProtocolMsg(webRtcChangeGamesReq);
    const rpcInput = Protocol.RPCInput(
      "chikii.node.NodeExtObj",
      "ChangeGamesReq",
      req
    );
    const proMsg = DYLongLinkClient.getInstance().bulidProtocolRPCMsg(rpcInput);
    proMsg && DYWebRtcClient.getInstance().sendChannelData(proMsg);
  }
}
